// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4cf39b30","455":"fd525486"}[chunkId] + ".chunk.js";
};